import React from "react";
import { LinkedRecord } from "../domain/LinkedRecord";
import { LinkedRecordsState } from "../redux/state";
import { getLinkRecordTypeTitle } from "../domain/LinkedRecordType";
import {
  LinkedRecordViewModel,
  toViewModel,
} from "../domain/LinkedRecordViewModel";
import { segmentList } from "@ofqual/portal-core/core/utils/listHelpers";
import { LinkedRecordsListSegment } from "./LinkedRecordsListSegment";

type LinkedRecordsListProps = {
  state: LinkedRecordsState;
  entityId: string;
};

export const LinkedRecordsList: React.FC<LinkedRecordsListProps> = ({
  state,
  entityId,
}) => {
  const orderedViewModels = orderData(state.response.data, entityId);
  const segentedData = segmentData(orderedViewModels);

  return (
    <>
      {segentedData.map((segment) => (
        <LinkedRecordsListSegment
          key={segment.label}
          segment={segment}
          entityId={entityId}
        />
      ))}
    </>
  );
};

const orderData = (records: LinkedRecord[], entityId: string) => {
  const viewModels = records
    .map((record) => toViewModel(entityId, record))
    .sort(sortFunction);
  return viewModels;
};

const sortFunction = (a: LinkedRecordViewModel, b: LinkedRecordViewModel) => {
  if (a.linkedEntityType < b.linkedEntityType) {
    return -1;
  } else if (a.linkedEntityType > b.linkedEntityType) {
    return 1;
  } else {
    if (a.createdDate < b.createdDate) {
      return -1;
    } else if (a.createdDate > b.createdDate) {
      return 1;
    } else {
      return 0;
    }
  }
};

const segmentData = (viewModels: LinkedRecordViewModel[]) => {
  return segmentList(viewModels, (item) =>
    getLinkRecordTypeTitle(item.linkedEntityType)
  );
};
